import React from 'react';

/**
 * @function Footer
 * @return {JSX.Element}
 * @constructor
 */
export default () => (
    <footer className="h-5-screen bg-app-dark flex items-center justify-center font-gilroy text-sm">
        <a href="https://www.speedo.com/uk/en/privacy-policy.html" target="_blank"
           className="text-white hover:underline">
            Privacy Policy
        </a>
    </footer>
);
